import React from "react"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import "./i18n"
import { BrowserRouter } from "react-router-dom"
import { GoogleOAuthProvider } from '@react-oauth/google';

import { Provider } from "react-redux"
import store from "./store"
import ReactDOM from "react-dom/client";

window.process = { env: { NODE_ENV: 'development' } };
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <GoogleOAuthProvider clientId="583999385549-amlaq752cc4kako6kel2o0mnrpv4mbj0.apps.googleusercontent.com">
      <App />
      </GoogleOAuthProvider>
    </BrowserRouter>
  </Provider>
)

serviceWorker.unregister()
